import type { HelpFile } from '../../types/help'
import { ReportCategoriesPageTestIds } from '../../../testids/ReportCategoriesPageTestIds'

export const reportCategoriesPageHelp: HelpFile = {
  docPage: '/docs/reporting/categories',
  texts: {
    [ReportCategoriesPageTestIds.categoriesPage]:
      'Ordnerstruktur zur Gliederung von Berichtsdefinitionen.',
    [ReportCategoriesPageTestIds.btnCreateCategory]:
      'Neue Berichtskategorie anlegen.',
    [ReportCategoriesPageTestIds.btnPickParentCategory]:
      'Übergeordnete Kategorie wählen, unter der diese eingeordnet wird.',
    [ReportCategoriesPageTestIds.selectCategoryType]:
      'Nach Kategorietyp filtern.',
    [ReportCategoriesPageTestIds.colName]: null,
    [ReportCategoriesPageTestIds.colCategory]:
      'Übergeordnete Kategorie, zu der dieser Eintrag gehört.',
    [ReportCategoriesPageTestIds.colType]: null,
    [ReportCategoriesPageTestIds.colLastModified]: null,
    [ReportCategoriesPageTestIds.colActions]: null,
    [ReportCategoriesPageTestIds.colNameSearch]:
      'Nach Kategoriename filtern.',
    [ReportCategoriesPageTestIds.colCategorySearch]:
      'Nach übergeordneter Kategorie filtern.',
    [ReportCategoriesPageTestIds.colTypeSearch]:
      'Nach Kategorietyp filtern.',
    [ReportCategoriesPageTestIds.colLastModifiedSearch]:
      'Nach Datum der letzten Änderung filtern.',
  },
}
